<script lang="ts">
	import type { Snippet } from "svelte";
	import RouteMap from "./route-map.svelte";
	import SvgIcon from "./svg-icon.svelte";
	import { initFluentContext, Localized } from "../localization";

	interface Props {
		routeDataSelector: string;
		poiDataSelector: string;
		accesstoken: string;
		zoom: number;
		bearing: number;
		pitch: number;
		children?: Snippet;
	}

	let { routeDataSelector, poiDataSelector, accesstoken, zoom, bearing, pitch, children }: Props = $props();

	initFluentContext();

	let showOverlay: boolean = $state(true);
	// `export function` on a component is reached through `bind:this` in runes mode.
	let routeMap: ReturnType<typeof RouteMap> | undefined = $state();

	function onInteractiveChanged(detail: { isInteractive: boolean }) {
		showOverlay = !detail.isInteractive;
	}
</script>

<div>
	<RouteMap bind:this={routeMap} {routeDataSelector} {poiDataSelector} {accesstoken} {zoom} {bearing} {pitch} zoomToExtents={true} offset={[0, 70]} hideInteractiveToggle={children != null} oninteractivechanged={onInteractiveChanged} />
	{#if children != null}
		<div class="map-block__overlay" class:is-visible={showOverlay}>
			<p class="map-block__overlay-text">
				{@render children()}
				<button class="button is-outlined is-responsive button-activate" onclick={() => routeMap?.toggleInteractive()}>
					<SvgIcon name="press-button" />
					<span><Localized id="map-activate-long" /></span>
				</button>
			</p>
		</div>
	{/if}
</div>

<style lang="scss">
    .button-activate {
        vertical-align: middle;
    }
</style>
